package com.vizio.redwolf.pay.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class OfferIdByLinkingPinResponse(
    val offerId: String? = null
)